module.exports = __webpack_public_path__ + "static/media/pamp.cb20f95b.svg";